import {
  AccountCircleOutlined,
  FaceBook,
  Instagram,
  ShareOutlined,
  Twitter,
} from "../assets";
import { IconButton } from "@mui/material";
import { useCallback } from "react";

export const getIcon = (tag) => {
  switch (tag) {
    case "facebook":
      return <FaceBook />;
    case "instagram":
      return <Instagram />;
    case "twitter":
      return <Twitter />;
    case "share":
      return <ShareOutlined />;
    default:
      return <AccountCircleOutlined />;
  }
};

const IconBtn = ({ icon, id, route }) => {
  const handleClick = useCallback(
    (e) => {
      const url = `https://${window.location.hostname}/${route}/${id}`;
      switch (icon) {
        case "facebook":
          window.open(`https://www.facebook.com/sharer/sharer.php?u=${url}`);
          return;
        case "insta":
          return;
        default:
          window.open(`https://www.twitter.com/intent/tweet/?url=${url}`);
          return;
      }
    },
    [icon, id, route]
  );

  return (
    <IconButton sx={{ p: 0, mr: 2 }} onClick={handleClick}>
      {getIcon(icon)}
    </IconButton>
  );
};

export default IconBtn;
